import { render, staticRenderFns } from "./register.vue?vue&type=template&id=6429a27f&scoped=true"
import script from "./register.vue?vue&type=script&lang=js"
export * from "./register.vue?vue&type=script&lang=js"
import style0 from "./register.vue?vue&type=style&index=0&id=6429a27f&prod&lang=scss&scoped=true"
import style1 from "./register.vue?vue&type=style&index=1&id=6429a27f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6429a27f",
  null
  
)

export default component.exports